import React from 'react';
import { ErrorBoundary } from './ErrorBoundary';

interface NavigationErrorBoundaryProps {
  children: React.ReactNode;
}

export function NavigationErrorBoundary({ children }: NavigationErrorBoundaryProps) {
  return (
    <ErrorBoundary
      fallback={
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="text-center p-8">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">Navigation Error</h1>
            <p className="text-gray-600 mb-6">
              There was an error navigating to this page. Please try refreshing or go back to the home page.
            </p>
            <button
              onClick={() => window.location.href = '/'}
              className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Go to Home
            </button>
          </div>
        </div>
      }
    >
      {children}
    </ErrorBoundary>
  );
}
